import { createFileRoute, getRouteApi } from '@tanstack/react-router'
import { ControlRoomPage } from '@features/projects/components/WorkflowSessionPage/ControlRoomPage'
import { WorkflowStateLoader } from '@features/projects/components/WorkflowSessionPage/SessionLoaders'

const routeApi = getRouteApi(
  '/_auth/o/$orgId/projects/$projectId/$workflowSessionId/control'
)

const ControlRoomSessionRoute = () => {
  const { workflowSessionId } = routeApi.useParams()

  return (
    <WorkflowStateLoader workflowSessionId={workflowSessionId}>
      <ControlRoomPage />
    </WorkflowStateLoader>
  )
}

export const Route = createFileRoute(
  '/_auth/o/$orgId/projects/$projectId/$workflowSessionId/control'
)({
  component: ControlRoomSessionRoute,
  loader: () => ({
    crumb: 'Control',
  }),
})
